export default __webpack_public_path__ + "static/media/ep2_andrea_annoyed.1ce73609.jpg";